module.exports = __webpack_public_path__ + "static/img/huanqiu.d236fd1a.jpg";